
(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { });

	

	// $('.nhm-slick-1').slick({
	// 	dots: true,
	// 	speed: 300,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	// 	focusOnSelect: true,
	//     autoplaySpeed: 6000,
	//     // asNavFor: '.lsi-property-slick-nav',
	// });
	// 
	
	

	// $('.nhm-slick-2').slick({
	// 	dots: true,
	// 	speed: 600,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	centerPadding: 0,
	// 	arrows: true,
	// 	focusOnSelect: true,
	//     autoplaySpeed: 3000,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	//     responsive: [
	// 				    {
	// 				      	breakpoint: 991,
	// 				      	settings: {
	// 				        	slidesToShow: 2,
	// 				      	}
	// 				    },
	// 				    {
	// 				      	breakpoint: 500,
	// 				      	settings: {
	// 				        	slidesToShow: 1,
	// 				      	}
	// 				    },
	//     			]
	// });


	$('.nhm-highlight-section.-slick').slick({
		dots: false,
		speed: 600,
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: true,
		focusOnSelect: true,
	    autoplaySpeed: 3000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
					    // {
					    //   	breakpoint: 500,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
	    			]
	});


	$('.nhm-assessments-list').slick({
		dots: false,
		speed: 600,
		infinite: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		centerPadding: 0,
		arrows: true,
		focusOnSelect: true,
	    autoplaySpeed: 3000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
					    // {
					    //   	breakpoint: 500,
					    //   	settings: {
					    //     	slidesToShow: 1,
					    //   	}
					    // },
	    			]
	});


	$('.nhm-areas-cards.-slick').slick({
		// dots: false,
		dots: true,
		// speed: 600,
		speed: 800,
		infinite: true,
		// autoplay: false,
		autoplay: true,
		slidesToShow: 4,
		// slidesToScroll: 1,
		slidesToScroll: 4,
		centerMode: false,
		centerPadding: 0,
		// arrows: true,
		arrows: false,
		focusOnSelect: true,
	    autoplaySpeed: 4000,
		// prevArrow: '<span class="slick-prev btn -square icon-arrow-l"></span>',
		// nextArrow: '<span class="slick-next btn -square icon-arrow-r"></span>',
		prevArrow: '<span class="slick-prev btn  -square"><iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon></span>',
		nextArrow: '<span class="slick-next btn  -square"><iconify-icon icon="iconamoon:arrow-right-2-duotone"></iconify-icon></span>',
	    responsive: [
					    // {
					    //   	breakpoint: 991,
					    //   	settings: {
					    //     	slidesToShow: 4,
					    //   	}
					    // },
					    {
					      	breakpoint: 500,
					      	settings: {
					        	slidesToShow: 2,
								// slidesToScroll: 1,
								slidesToScroll: 2,
					      	}
					    },
	    			]
	});




	





	window.addEventListener('resize', function(event){



	});
	

    
}(window.jQuery, window, document));